export default __webpack_public_path__ + "v1.18.25/static/media/back-arrow.9e35e3eb.svg";